(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colorgallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slider = document.querySelector('[data-slider] .color-gallery-slider-track');
    const dots = document.querySelectorAll('.color-gallery-dot');

    if (!slider || dots.length === 0) return;

    // Update active dot based on scroll position
    function updateActiveDot() {
      const scrollLeft = slider.scrollLeft;
      const slideWidth = slider.querySelector('.color-gallery-slide').offsetWidth + 16; // width + gap
      const activeIndex = Math.round(scrollLeft / slideWidth);

      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    // Scroll to slide when dot is clicked
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slideWidth = slider.querySelector('.color-gallery-slide').offsetWidth + 16;
        slider.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });
      });
    });

    // Update dots on scroll
    slider.addEventListener('scroll', updateActiveDot);

    // Initialize
    updateActiveDot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Maaler meddelelseslinjerne over og under headeren til den klaebende stak.
       Sektionen kan staa flere gange i header-gruppen, saa kun én instans. */
    if (window.__mlStickyStak) return;
    window.__mlStickyStak = true;

    let observer = null;

    const opsaet = () => {
      const gruppe = document.getElementById('header-group');
      const headerSektion = gruppe && gruppe.querySelector(':scope > .header-section');
      const header = headerSektion && headerSektion.querySelector('#header-component');
      if (observer) observer.disconnect();

      if (!header || header.getAttribute('sticky') !== 'always') {
        document.body.classList.remove('ml-sticky-stak');
        return;
      }

      const over = [];
      const under = [];
      let efterHeader = false;
      for (const el of gruppe.children) {
        if (el === headerSektion) { efterHeader = true; continue; }
        if (!el.querySelector(':scope > .announcement-bar')) continue;
        el.setAttribute('data-ml-annonce', efterHeader ? 'under' : 'over');
        (efterHeader ? under : over).push(el);
      }

      const maal = () => {
        const hoejde = (el) => el.getBoundingClientRect().height;
        let foran = 0;
        for (const el of over) { el.style.setProperty('--ml-foran', foran + 'px'); foran += hoejde(el); }
        document.body.style.setProperty('--ml-annonce-over', foran + 'px');
        let foranUnder = 0;
        for (const el of under) { el.style.setProperty('--ml-foran', foranUnder + 'px'); foranUnder += hoejde(el); }
        document.body.style.setProperty('--ml-annonce-under', foranUnder + 'px');
        document.body.classList.add('ml-sticky-stak');
      };

      maal();
      observer = new ResizeObserver(maal);
      for (const el of [...over, ...under]) observer.observe(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', opsaet);
    } else {
      opsaet();
    }
    document.addEventListener('shopify:section:load', opsaet);
    document.addEventListener('shopify:section:unload', () => setTimeout(opsaet, 0));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
